import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { List, X, Globe, ArrowRight } from "@phosphor-icons/react";
import { useLandingT } from "@/lib/landingI18n";
import { LANDING } from "@/constants/landingTestIds";

export const LandingNav = ({ lang, setLang }) => {
  const t = useLandingT(lang);
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const nav = [
    { href: "#features", label: t("navFeatures") },
    { href: "#how", label: t("navHowItWorks") },
    { href: "#pricing", label: t("navPricing") },
    { href: "#faq", label: t("navFaq") },
  ];

  return (
    <header
      className={`sticky top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-[#0a192f]/85 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1240px] mx-auto px-5 md:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
        <Link
          to="/"
          className="flex items-center gap-3 text-white group"
          aria-label="LoadWise home"
        >
          <img
            src="/branding/loadwise-logo-192.png"
            alt="LoadWise"
            className="h-10 md:h-11 w-auto transition-transform group-hover:scale-[1.03]"
            style={{ filter: "drop-shadow(0 0 14px rgba(16,185,129,0.35))" }}
            draggable="false"
          />
          <span className="hidden md:inline text-[10px] uppercase tracking-[0.22em] text-emerald-400/80 leading-none font-medium">
            Smarter Loads. Bigger Profits.
          </span>
          <span className="sr-only">LoadWise</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8 text-sm text-slate-300">
          {nav.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="hover:text-white transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            data-testid={LANDING.langToggle}
            onClick={() => setLang(lang === "en" ? "ar" : "en")}
            className="hidden sm:flex items-center gap-2 text-slate-300 hover:text-white px-3 py-2 rounded-lg border border-white/10 hover:border-white/25 transition-colors text-sm"
          >
            <Globe size={14} weight="bold" />
            {lang === "en" ? "عربي" : "EN"}
          </button>
          <Link
            data-testid={LANDING.navCta}
            to="/app"
            className="btn-neon inline-flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm"
          >
            {t("navCta")}
            <ArrowRight size={14} weight="bold" className="flip-x" />
          </Link>
          <button
            onClick={() => setOpen((o) => !o)}
            className="lg:hidden text-white p-2 rounded-lg border border-white/10"
            aria-label="menu"
          >
            {open ? <X size={18} /> : <List size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#0a192f]/95 backdrop-blur-xl">
          <div className="px-5 py-4 flex flex-col gap-3">
            {nav.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="text-slate-200 py-2"
              >
                {n.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
